import { Component, ComponentRef, EventEmitter, inject, ViewChild, ViewContainerRef } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { RiberaDefaultBtn } from '@ribera-web/ribera-default-btn';
import { RiberaModalData } from '../models/ribera-modal-data';

@Component({
  selector: 'lib-ribera-modal-container-ui',
  imports: [ButtonModule, CommonModule, RiberaDefaultBtn],
  templateUrl: './ribera-modal-container-ui.html',
  styleUrl: './ribera-modal-container-ui.scss',
})
export class RiberaModalContainerUi {

  private ref = inject(DynamicDialogRef);
  private config = inject(DynamicDialogConfig);

  @ViewChild('container', {
    read: ViewContainerRef,
    static: true
  })

  container!: ViewContainerRef;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  componentRef!: ComponentRef<any>;

  get data(): RiberaModalData {
    return this.config.data;
  }

  ngAfterViewInit(): void {

    this.container.clear();

    this.componentRef = this.container.createComponent(
      this.data.component,
      {
        injector: this.data.injector
      }
    );

    const instance = this.componentRef.instance;

    /**
     * Escucha outputs dinámicos
     */
    if (instance.submitData instanceof EventEmitter) {

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      instance.submitData.subscribe((data: any) => {

        this.ref.close(data);

      });

    }

  }

  formularioInvalido = '';

  close() {
    this.formularioInvalido = '';

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const instance = this.componentRef?.instance as any;

    if (typeof instance?.submit === 'function') {

      const result = instance.submit();

      // ❌ solo bloquea si no hay nada realmente útil
      if (result === undefined || result === null) {
        return;
      }

      // ✅ validación de objeto vacío (opcional)
      if (typeof result === 'object' && !Array.isArray(result)) {

        const hasValues = Object.values(result)
          .some(value => value !== null && value !== undefined && value !== '');

        if (!hasValues) {
          this.formularioInvalido = "Formulario inválido";
          return;
        }
      }

      this.ref.close(result);
      return;
    }

    // componente solo visual
    this.ref.close(true);
  }

  cancel() {
    this.ref.close(false);
  }

}
